import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
    filtered: boolean;
    onClear: () => void;
}

const RecordListEmptyState = ({ filtered, onClear }: Props) => {
    const { t } = useTranslation();
    return (
        <Box role="status" sx={{ minHeight: 180, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, px: 2 }}>
            <Typography color="text.secondary">
                {t(filtered ? "No records match the current filters." : "No records found.")}
            </Typography>
            {filtered && <Button variant="outlined" onClick={onClear}>{t("Clear filters")}</Button>}
        </Box>
    );
};

export default RecordListEmptyState;
